import { NavLink, Outlet } from 'react-router-dom'
import { PageHeader } from '../../components/ui/PageHeader'
import { useAuth } from '../../context/AuthContext'
import { PERMISSION_KEYS } from '../../config/permissions'
import { tabLink, tabsWrapClass } from '../../lib/ui'

/** Раздел планирования производства — `/planning`. */
export function PlanningLayout() {
  const { can } = useAuth()

  const tabs: { to: string; label: string; show: boolean }[] = [
    { to: '/planning/schedule', label: 'График', show: can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ) },
    { to: '/planning/queue', label: 'Очередь', show: can(PERMISSION_KEYS.PRODUCTION_REQUESTS_READ) },
    { to: '/planning/output', label: 'Выработка', show: can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ) },
    { to: '/planning/timesheets', label: 'Табель', show: can(PERMISSION_KEYS.TIMESHEETS_READ) },
    { to: '/planning/materials', label: 'Материалы', show: can(PERMISSION_KEYS.MATERIALS_READ) },
    { to: '/planning/kiosk', label: 'Экран смены', show: can(PERMISSION_KEYS.PLANNING_KIOSK) },
    { to: '/planning/kpi', label: 'KPI', show: can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ) },
    { to: '/planning/oee', label: 'OEE', show: can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ) },
    { to: '/planning/costs', label: 'Себестоимость', show: can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ) },
    { to: '/planning/fulfillment', label: 'Исполнение', show: can(PERMISSION_KEYS.PRODUCTION_REQUESTS_READ) },
    { to: '/planning/traceability', label: 'Прослеживаемость', show: can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ) },
  ]

  return (
    <div>
      <PageHeader
        title="Планирование"
        lead="График производства, очередь заявок, выработка, табель, аналитика и потребность в материалах."
      />
      <div className={tabsWrapClass}>
        {tabs
          .filter((t) => t.show)
          .map((t) => (
            <NavLink key={t.to} to={t.to} className={({ isActive }) => tabLink(isActive)}>
              {t.label}
            </NavLink>
          ))}
      </div>
      <div className="mt-5">
        <Outlet />
      </div>
    </div>
  )
}
